export default __webpack_public_path__ + "static/media/admin-truck-add-location.03c45bfb.png";